(() => {
  const template = document.getElementById('ChicNewsletterAppearance');
  if (!template || !window.customElements || window.chicNewsletterAppearanceReady) return;
  window.chicNewsletterAppearanceReady = true;

  const styledRoots = new WeakSet();
  const enhance = (host) => {
    const root = host.shadowRoot;
    if (!root || styledRoots.has(root)) return;
    styledRoots.add(root);
    const apply = () => {
      if (!root.querySelector('style[data-chic-newsletter-appearance]')) {
        const style = template.content.querySelector('style');
        if (style) root.appendChild(style.cloneNode(true));
      }
      const collage = document.getElementById('ChicNewsletterCollage')?.content.firstElementChild;
      if (!collage) return;
      root.querySelectorAll('.appEmbed[data-layout="overlay"] section[role="dialog"][data-sizing="form-wrapper"]').forEach((panel) => {
        if (!panel.querySelector(':scope > .chic-newsletter-collage')) panel.prepend(collage.cloneNode(true));
      });
    };
    apply();
    new MutationObserver(apply).observe(root, { childList: true, subtree: true });
  };

  const scan = (node) => {
    if (node.nodeType === Node.ELEMENT_NODE && node.matches('shopify-forms-embed')) enhance(node);
    if (node.querySelectorAll) node.querySelectorAll('shopify-forms-embed').forEach(enhance);
  };

  customElements.whenDefined('shopify-forms-embed').then(() => {
    scan(document);
    new MutationObserver((records) => {
      records.forEach((record) => record.addedNodes.forEach(scan));
    }).observe(document.body, { childList: true, subtree: true });
  });
})();
